export default __webpack_public_path__ + "static/media/ceramx-cloud-farbe.9ee5ff27.png";